import { Store } from 'vuex';

import { AppState } from '@/store/types';
import { RouteLocationNormalized } from 'vue-router';
import { captureError } from '../RUMService/RUMService';

/**
 * Function to fetch listing data for the current route
 */
export async function fetchFormData(
  store: Store<AppState>,
  route: RouteLocationNormalized,
  passThroughHeaders: Record<string, string>,
): Promise<void> {
  const { listingId } = route.params;

  if (!listingId) {
    return;
  }

  try {
    const languageCode = route?.meta?.locale ?? 'de';

    await store.dispatch('immocheckValuation/prefetchListingDataById', {
      listingId,
      passThroughHeaders,
      languageCode,
    });
  } catch (error) {
    captureError(error);
  }
}
